export default __webpack_public_path__ + "static/media/call.e367455d.svg";